// @ts-nocheck
import React from "react";

import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

class SelectField extends React.PureComponent {
  renderSelectField = () => {
    const {
      checkbox,
      checked,
      id,
      input,
      onBlur,
      onChange,
      onFocus,
      value,
      variant,
      size,
      label,
      renderValue,
    } = this.props;
    let customProps = {};

    if (checkbox) {
      customProps = {
        ...customProps,
        multiple: true,
        value: checked,
        renderValue: this.renderCheckboxSelectFieldValue,
      };
    }

    if (renderValue) {
      customProps = {
        ...customProps,
        renderValue: renderValue,
      };
    }

    const SelectComponent = (
      <Select
        {...input}
        labelId="select-field-input-label"
        value={value === undefined ? input?.value || "" : value}
        {...customProps}
        variant={variant}
        size={size}
        id={id}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        label={label}
      >
        {this.renderMenuItems(customProps)}
      </Select>
    );

    return variant === "outlined" ? (
      <FormControl size={size}>
        <InputLabel id="select-field-input-label">{label}</InputLabel>
        {SelectComponent}
      </FormControl>
    ) : (
      SelectComponent
    );
  };

  renderCheckboxSelectFieldValue = () => {
    const { checked, values } = this.props;

    const labels = checked.map((value, index) => {
      const str = values?.find((item) => item.value === value)?.text;

      return str ? `${str}, ` : null;
    });

    const result = labels.filter((label) => label !== null);

    // Remove the last comma
    if (result.length > 0) {
      result[result.length - 1] = result[result.length - 1].slice(0, -2);
    }

    return result;
  };

  renderMenuItems = () => {
    const { values } = this.props;
    return values?.map((item, index) => (
      <MenuItem key={`${item.value}-${index}`} value={item.value}>
        {this.renderMenuItem(item)}
      </MenuItem>
    ));
  };

  renderMenuItem = (item) => {
    const { checkbox, checked, onChange } = this.props;

    if (checkbox) {
      return (
        <>
          <Checkbox
            color="primary"
            checked={checked.indexOf(item.value) > -1}
            onChange={(e) => {
              if (e.target.checked) {
                onChange([...checked, item.value]);
              }
            }}
          />
          <ListItemText primary={item.text} />
        </>
      );
    }

    return item.text;
  };

  render() {
    const { variant, disabled, fullWidth, id, label, margins, required } =
      this.props;

    return (
      <>
        <FormControl
          variant={variant}
          fullWidth={fullWidth}
          disabled={disabled}
          required={required}
          margin="none"
          margins={margins}
        >
          {variant !== "outlined" && (
            <InputLabel htmlFor={id}>{label}</InputLabel>
          )}
          {this.renderSelectField()}
        </FormControl>
      </>
    );
  }
}

SelectField.defaultProps = {
  variant: "standard",
  checkbox: false,
  checked: [],
  disabled: false,
  fullWidth: true,
  margins: null,
  input: { value: "" },
  loading: false,
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  required: false,
  value: undefined,
};

export default SelectField;
